<template>
	<div>
		<p class="mycoupon">我的优惠券</p>
		<div class="Vouchers" v-for="coupon in mycoupon">
     			<div class="VouchersLeft">
     				<div class="amountNumber"><span>{{coupon.price}}</span> 元<i>{{coupon.name}}</i></div>
     				<p class="moneyTime">满{{coupon.condition}}可以使用</p>
     				<p class="moneyTime">有效期：{{coupon.time_out}}</p>
     				<b class="term" v-show="coupon.end_time_status==0?true:false">即将过期</b>
     			</div>
     			<div class="VouchersRight" @click="use(coupon)">立<br />即<br />使<br />用</div>
     		</div>
     		<!--<div class="clear"></div>-->
	</div>
</template>

<script>
	export default{
		name:"Mycoupons",
		data(){
			return{
				mycoupon:[],
			}
		},
		methods:{
			use(coupon){
				if(coupon.headcid==null){
					this.$router.push({name:"courseList"})
				}else{
					this.$router.push({name:"CourseDetails",params:{id:coupon.headcid}})
				}
			}
		},
		mounted(){
			var that=this
			that.$ajax({
				method:"post",
				url:"/api/mycouponlist"
			}).then(function(data){
				that.mycoupon=data.data.result
			}).catch(function(err){
				console.log(err)
			})
		}
	}
</script>

<style>
	.mycoupon{font-size: 20px;color:rgba(79,79,79,1);margin:30px 0 20px 30px;}
	.Vouchers{width:348px;height:125px;background: url(../../assets/youhui1.png) no-repeat -16px -6px;margin:0 16px 20px 30px;float: left;}
    .VouchersLeft{width:290px;height:125px;float: left;border-right:1px dotted #29b999;position: relative;}
    .VouchersRight{width:52px;float: left;color:#fff;font-size: 18px;text-align: center;margin-top: 20px;}
    .amountNumber{margin: 24px 0 12px 24px;color: #fff;}
    .amountNumber span{font-size: 24px;}
    .amountNumber i{font-style: normal;margin-left:12px;color: ;}
    .moneyTime{margin-left: 24px;color: #a8ebe8;}
    .term{width: 70px;height: 20px;background: #fff;color: #00b883;display: inline-block;margin-left: 10px;text-align: center;border-radius: 4px;font-weight: 100;position: absolute;right: 10px;bottom: 26px;}
    .clear{clear: both;}
    /*.router-link-active{background:#11cc99;color:#fff;}*/
</style>


// WEBPACK FOOTER //
// Mycoupons.vue?1edfba56